import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

interface SignatureCaptureProps {
  onSave: (signatureImage: string) => void;
  role: string;
}

const SignatureCapture: React.FC<SignatureCaptureProps> = ({ onSave, role }) => {
  const sigCanvas = useRef<SignatureCanvas>(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const clear = () => {
    sigCanvas.current?.clear();
    setIsEmpty(true);
  };

  const save = () => {
    if (isEmpty) {
      alert('Por favor firme antes de guardar');
      return;
    }
    
    const dataURL = sigCanvas.current?.toDataURL('image/png');
    if (dataURL) onSave(dataURL);
  };

  const handleBeginStroke = () => {
    setIsEmpty(false);
  };

  return (
    <div className="border p-4 rounded bg-white">
      <h3 className="text-lg font-semibold mb-2">Firma de {role}</h3>
      <div className="border-2 border-gray-300 mb-2">
        <SignatureCanvas
          ref={sigCanvas}
          onBegin={handleBeginStroke}
          canvasProps={{
            width: 500,
            height: 200,
            className: 'signature-canvas'
          }}
          backgroundColor="white"
        />
      </div>
      <div className="text-gray-500 text-sm mb-2">
        Firme dentro del recuadro utilizando el ratón o pantalla táctil
      </div>
      <div className="flex space-x-2">
        <button 
          onClick={clear}
          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
        >
          <i className="fas fa-eraser mr-1"></i> Borrar
        </button>
        <button 
          onClick={save}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
          disabled={isEmpty}
        >
          <i className="fas fa-save mr-1"></i> Guardar firma
        </button>
      </div>
    </div>
  );
};

export default SignatureCapture; 